import { get } from 'jquery';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        isLoaderShown: true,
        iconDocs: {},
        iconIndex: {},
        iconOfficeDocs: {},
        iconOfficeIndex: {},
        categories: {},
        customViews: {},
        loadingIcons: true,
        loginURL: "",
        isUserLogin: false,
        theme: {},
        roleAdmin: false,
        roleDesgin: false,
        roleIntegration: false,
        roleProcessAdmin: false,
        roleUser: false,
        roleUserAdmin: false,
        roleFullAPI: false,
        flowDesignerLicense: false,
        flowCoreLicense: false,
        ssoLicenseAdmin: false,
        enablePrivacyPolicy: "false",
        privacyPolicyLinkName: "",
        privacyPolicyLinkUrl: "",
        helpUrl: "",
        userDefinedThemes: [],
        themeDialog: false,
        previewMode: false,
        userProfile: {},
        selectedWorksPlace: "",
        worksplaceReferences:[],
        isAdvancedSSO: false,
        isEndDrawerActive: false,
        isSmallScreen: false,
        isDrawerOpen: true,
        organisationReferences:""
    },
    mutations: {
        setDrawerStatus(state, value)
        {
            state.isDrawerOpen = value
        },
        setSmallScreenStatus(state, value)
        {
            state.isSmallScreen = value
        },
        setEndDrawerStatus(state, value) {
             state.isEndDrawerActive = value
        },
        showLoader(state, payload) {
            state.isLoaderShown = payload
        },
        setCategories(state, categories) {
            state.categories = Object.assign({}, categories)
        },
        setIconDocs(state, obj) {
            state.iconDocs = Object.assign({}, obj)
        },
        setIconIndex(state, obj) {
            state.iconIndex = Object.assign({}, obj)
        },
        setOfficeIconDocs(state, obj) {
            state.iconOfficeDocs = Object.assign({}, obj)
        },
        setOfficeIconIndex(state, obj) {
            state.iconOfficeIndex = Object.assign({}, obj)
        },
        setCustomViews(state, customViews) {
            state.customViews = Object.assign({}, customViews)
        },
        setLoadingIcons(state, loadingIcons) {
            state.loadingIcons = loadingIcons;
        },
        setLoginUrl(state,url) {
            state.loginURL = url;
        },
        setIsUserLogin(state,isUserLogin) {
            state.isUserLogin = isUserLogin;
        },
        setThemeData(state, theme) {
            state.theme = Object.assign({}, theme);
        },
        setUserRoles(state,roles) {
            if(roles != ""){
                state.roleAdmin = roles.includes("ROLE_ADMIN") || roles.includes("ROLE_adv.bpm.administrator");
                state.roleDesgin = roles.includes("ROLE_DESIGN") || roles.includes("ROLE_adv.bpm.design");
                state.roleIntegration = roles.includes("ROLE_INTEGRATION") || roles.includes("ROLE_adv.bpm.integration");
                state.roleProcessAdmin = roles.includes("ROLE_PROCESS_ADMIN") ;
                state.roleUser = roles.includes("ROLE_USER") || roles.includes("ROLE_adv.bpm.user");
                state.roleUserAdmin = roles.includes("ROLE_USER_ADMIN") || roles.includes("ROLE_adv.bpm.user-admin");
                state.roleFullAPI = roles.includes("ROLE_FULL_API");
            }
        },
        setLicenses(state,licenses) { //MWPAP-16438
            if(licenses){
                state.flowDesignerLicense = licenses.includes("PFD") ;
                state.flowCoreLicense = licenses.includes("PFC");
            }
        },
        setRoles(state,roles) { 
            if(roles){
                state.ssoLicenseAdmin = roles.includes("ssoLicenseAdmin") ;
            }
        },
        setEnablePrivacyPolicy(state,enablePrivacyPolicy) {
            state.enablePrivacyPolicy = enablePrivacyPolicy;
        },
        setPrivacyPolicyLinkName(state,privacyPolicyLinkName) {
            state.privacyPolicyLinkName = privacyPolicyLinkName;
        },
        setPrivacyPolicyLinkUrl(state,privacyPolicyLinkUrl) {
            state.privacyPolicyLinkUrl = privacyPolicyLinkUrl;
        },
        setHelpUrl(state,helpUrl) {
            state.helpUrl = helpUrl;
        },
        setUserDefinedThemes(state,payload){
            state.userDefinedThemes = payload
        },
        setThemeDialog(state,payload) {
            state.themeDialog = payload
        },
        setPreviewMode(state,payload){
            state.previewMode = payload
        },
        setUserProfile(state,payload) {
            state.userProfile = payload
        },
        setSelectedWorksPlace(state,payload) {
            state.selectedWorksPlace = payload.selectedWorkplace
        },
        setWorksPlaceReferences(state,payload) {
            state.worksplaceReferences = payload.workplaceReference
        },
        setOrganisationReferences(state,organisationReferences) {
            state.organisationReferences = organisationReferences
        },
        setIsAdvancedSSO(state,result) {
            if(result.selectedWorkplace){
                state.isAdvancedSSO = true
            }
            
        }
    },
    getters: {
        getDrawerStatus: state =>{
            return state.isDrawerOpen;
        },
        getSmallScreenStatus: state =>{
            return state.isSmallScreen;
        },
        getEndDrawerStatus: state =>{
            return state.isEndDrawerActive;
        },
        getLoginUrl: state => {
            return state.loginURL;
        },
        getIsUserLogin: state => {
            return state.isUserLogin;
        },
        getRoleAdmin: state => {
            return state.roleAdmin;
        },
        getRoleDesign: state => {
            return state.roleDesgin;
        },
        getRoleIntegration: state => {
            return state.roleIntegration;
        },
        getRoleProcessAdmin: state => {
            return state.roleProcessAdmin;
        },
        getRoleUser: state => {
            return state.roleUser;
        },
        getRoleUserAdmin: state => {
            return state.roleUserAdmin;
        },
        getRoleFullAPI: state => {
            return state.roleFullAPI;
        },
        getFlowDesignerLicense: state => {
            return state.flowDesignerLicense;
        },
        getFlowCoreLicense: state => {
            return state.flowCoreLicense;
        },
        getSsoLicenseAdmin: state => {
            return state.ssoLicenseAdmin;
        },
        getCategories: state => {
            return state.categories;
        },
        getIconDocs: state => {
            return state.iconDocs;
        },
        getIconIndex: state => {
            return state.iconIndex;
        },
        getIconOfficeDocs: state => {
            return state.iconOfficeDocs;
        },
        getIconOfficeIndex: state => {
            return state.iconOfficeIndex;
        },
        getCustomViews: state => {
            return state.customViews;
        },
        getLoadingIcons: state => {
            return state.loadingIcons;
        },
        getThemeData: state => {
            return state.theme;
        },
        getEnablePrivacyPolicy: state => {
            return state.enablePrivacyPolicy;
        },
        getPrivacyPolicyLinkName: state => {
            return state.privacyPolicyLinkName;
        },
        getPrivacyPolicyLinkUrl: state => {
            return state.privacyPolicyLinkUrl;
        },
        getHelpUrl: state => {
            return state.helpUrl;
        },
        getUserDefinedThemes: state => {
            return state.userDefinedThemes;
        },
        getThemeDialog: state=> {
            return state.themeDialog;
        },
        getPreviewMode: state=>{
            return state.previewMode;
        },
        getThemeFromCode: state => code => {
            let obj = state.userDefinedThemes.find(o => o.code === code);
            return obj
        },
        getUserProfile: state=> {
            return state.userProfile;
        },
        getSelectedWorksPlace: state => {
            return state.selectedWorksPlace;
        },
        getWorksPlaceReferences: state => {
            return state.worksplaceReferences;
        },
        getOrganisationReferences: state => {
            return state.organisationReferences;
        },
        getIsAdvancedSSO: state => {
            return state.isAdvancedSSO;
        }
    },
    actions: {
        fetchLoginUrl(store, result) {
            store.commit('setLoginUrl', result);
        },
        fetchIsUserLogin(store, result) {
            store.commit('setIsUserLogin', result);
        },
        fetchUserRoles(store, result) {
            store.commit('setUserRoles', result);
        },
        fetchRole(store, result) {
            store.commit('setRoles', result);
        },
        fetchLicenses(store, result) {
            store.commit('setLicenses', result);
        },
        fetchCategories(store, result) {
            store.commit('setCategories', result);
        },
        fetchIconDocs(store, result) {
            store.commit('setIconDocs', result);
        },
        fetchIconIndex(store, result) {
            store.commit('setIconIndex', result);
        },
        fetchOfficeIconDocs(store, result) {
            store.commit('setOfficeIconDocs', result);
        },
        fetchOfficeIconIndex(store, result) {
            store.commit('setOfficeIconIndex', result);
        },
        fetchCustomViews(store, result) {
            store.commit('setCustomViews', result);
        },
        fetchLoadingIcons(store, result) {
            store.commit('setLoadingIcons', result);
        },
        fetchThemeData(store, result) {
            store.commit('setThemeData', result);
        },
        fetchEnablePrivacyPolicy(store, result) {
            store.commit('setEnablePrivacyPolicy', result);
        },
        fetchPrivacyPolicyLinkName(store, result) {
            store.commit('setPrivacyPolicyLinkName', result);
        },
        fetchPrivacyPolicyLinkUrl(store, result) {
            store.commit('setPrivacyPolicyLinkUrl', result);
        },
        fetchHelpUrl(store, result) {
            store.commit('setHelpUrl', result);
        },
        fetchUserDefinedThemes(store, result) {
            store.commit('setUserDefinedThemes', result);
        },
        toggleThemeDialog(store) {
            store.commit('setThemeDialog',!this.state.themeDialog)
        },
        updatePreviewMode(store, payload)
        {
            store.commit('setPreviewMode', payload)
        },
        fetchUserProfile(store, result) {
            store.commit('setUserProfile',result);
        },
        updateSelectedWorksplace(store,result)
        {
            store.commit('setSelectedWorksPlace',result);
        },
        updateWorksplaceReferences(store,result)
        {
            store.commit('setWorksPlaceReferences',result)
        },
        updateOrganisationReferences(store, result)
        {
            store.commit('setOrganisationReferences',result);
        },
        fetchIsAdvancedSSO(store, result)
        {
            store.commit('setIsAdvancedSSO',result);
        }

    }
})